import { BlockedMode, RenderArgs } from "../components/BenefitGate.types";
import { EBenefitTypes, EShowMode } from "../enums/benefits.enums";
import { useBenefit } from "../hooks/useBenefits";
import { resolveText } from "./resolve-text";

export function useBenefitGateCore(
    benefit: EBenefitTypes,
    opts: {
        showWhenBlocked?: BlockedMode;
        blockedTooltip?: string | ((args: RenderArgs) => string);
        overlayLabel?: string | ((args: RenderArgs) => string);
    }
) {
    const showWhenBlocked = opts.showWhenBlocked ?? EShowMode.DISABLED;
    const { decision, entitlement } = useBenefit(benefit, { showWhenBlocked });

    const disabled = decision.mode === EShowMode.DISABLED;

    const args: RenderArgs = {
        disabled,
        mode: decision.mode,
        reason: decision.reason,
    };

    const tooltipTitle = resolveText(disabled, opts.blockedTooltip, args);
    const label = resolveText(disabled, opts.overlayLabel, args);

    return {
        decision,
        entitlement,
        disabled,
        args,
        tooltipTitle,
        label,
        tooltipEnabled: disabled && !!tooltipTitle,
    };
}
